// src/components/Gallery.jsx
import { useState } from "react";
import "../assets/css/page/gallery.css";
import Modal from "../components/Container/modal";

// Import all images (each used once)
import G1 from "../assets/img/gallery/G1.JPG";
import G2 from "../assets/img/gallery/G2.JPG";
import G3 from "../assets/img/gallery/G3.JPG";
import G4 from "../assets/img/gallery/G4.png";
import G5 from "../assets/img/gallery/G5.JPG";
import G6 from "../assets/img/gallery/G6.png";
import G7 from "../assets/img/gallery/G7.JPG";
import G8 from "../assets/img/gallery/G8.jpg";
import G9 from "../assets/img/gallery/G9.jpg";
import G10 from "../assets/img/gallery/G10.jpg";
import G11 from "../assets/img/gallery/G11.jpg";
import G12 from "../assets/img/gallery/G12.jpg";
import G13 from "../assets/img/gallery/G13.jpg";
import G14 from "../assets/img/gallery/G14.jpg";
import G15 from "../assets/img/gallery/G15.jpg";
import G16 from "../assets/img/gallery/G16.jpg";
import G17 from "../assets/img/gallery/G17.jpg";
import G18 from "../assets/img/gallery/G18.jpg";
import G19 from "../assets/img/gallery/G19.jpg";
import G20 from "../assets/img/gallery/G20.jpg";
import G21 from "../assets/img/gallery/G21.jpg";
import G22 from "../assets/img/gallery/G22.png";
import G23 from "../assets/img/gallery/G23.jpg";
import G24 from "../assets/img/gallery/G24.jpg";
import G25 from "../assets/img/gallery/G25.jpg";
import G26 from "../assets/img/gallery/G26.jpg";
import G27 from "../assets/img/gallery/G27.jpg";
import G28 from "../assets/img/gallery/G28.jpg";
import G29 from "../assets/img/gallery/G29.jpg";
import G30 from "../assets/img/gallery/G30.jpg";
import G31 from "../assets/img/gallery/G31.jpg";
import G32 from "../assets/img/gallery/G32.jpg";
import G33 from "../assets/img/gallery/G33.png";
import G34 from "../assets/img/gallery/G34.png";
import G35 from "../assets/img/gallery/G35.jpg";
import G36 from "../assets/img/gallery/G36.jpg";
import G37 from "../assets/img/gallery/G37.jpg";
import G38 from "../assets/img/gallery/G38.png";
import G39 from "../assets/img/gallery/G39.jpg";
import G40 from "../assets/img/gallery/G40.jpg";
import G41 from "../assets/img/gallery/G41.jpg";
import G42 from "../assets/img/gallery/G42.jpg";
import G43 from "../assets/img/gallery/G43.jpg";
import G44 from "../assets/img/gallery/G44.jpg";
import G45 from "../assets/img/gallery/G45.jpg";
import G46 from "../assets/img/gallery/G46.jpg";
import G47 from "../assets/img/gallery/G47.jpg";
import G48 from "../assets/img/gallery/G48.jpg";
import G50 from "../assets/img/gallery/G50.jpg";
import G51 from "../assets/img/gallery/G51.jpg";
import G52 from "../assets/img/gallery/G52.jpg";
import G53 from "../assets/img/gallery/G53.jpg";
import G54 from "../assets/img/gallery/G54.jpg";
import G55 from "../assets/img/gallery/G55.jpg";
import G56 from "../assets/img/gallery/G56.jpg";
import G57 from "../assets/img/gallery/G57.jpg";
import G58 from "../assets/img/gallery/G58.jpg";
import G59 from "../assets/img/gallery/G59.jpg";
import G60 from "../assets/img/gallery/G60.jpg";
import G61 from "../assets/img/gallery/G61.jpg";
import G62 from "../assets/img/gallery/G62.jpg";
import G63 from "../assets/img/gallery/G63.jpg";
import G64 from "../assets/img/gallery/G64.jpg";



const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImage, setCurrentImage] = useState({ src: "", alt: "" });

  // Updated categories
  const categories = [
    "All",
    "Braids & Cornrows",
    "Locs & Twists",
    "Weaves & Sew-In Styles",
    "Kids Styles",
    "Natural & Curly Styles",
  ];

  const B = "Braids & Cornrows";
  const L = "Locs & Twists";
  const W = "Weaves & Sew-In Styles";
  const K = "Kids Styles";
  const N = "Natural & Curly Styles";

  const images = [
    // Locs & Twists
    { src: G1, category: L },
    { src: G3, category: L },
    { src: G6, category: L },
    { src: G12, category: L },
    { src: G18, category: L},
    { src: G21, category: L },
    { src: G23, category: L },
    { src: G27, category: L },
    { src: G29, category: L },
    { src: G34, category: L },
    { src: G36, category: L },
    { src: G37, category: L },
    { src: G46, category: L },
    { src: G47, category: L },
    { src: G56, category: L },
    { src: G57, category: L },
    { src: G60, category: L },
    

    // Braids & Cornrows
    { src: G4, category: B },
    { src: G5, category: B },
    { src: G8, category: B },
    { src: G14, category: B },
    { src: G16, category: B },
    { src: G20, category: B },
    { src: G22, category: B },
    { src: G24, category: B },
    { src: G33, category: B },
    { src: G35, category: B },
    { src: G38, category: B },
    { src: G40, category: B },
    { src: G41, category: B },
    { src: G42, category: B },
    { src: G48, category: B },
    { src: G50, category: B },
    { src: G58, category: B },
    { src: G59, category: B },

    // Weaves & Sew-In Styles
    { src: G17, category: W },
    { src: G19, category: W },
    { src: G25, category: W },
    { src: G26, category: W },
    { src: G30, category: W },
    { src: G31, category: W },
    { src: G32, category: W },
    { src: G45, category: W },
    { src: G51, category: W },
    { src: G52, category: W },
    { src: G53, category: W },
    { src: G55, category: W },
    { src: G61, category: W },

    // Kids Styles
    { src: G7, category: K },
    { src: G9, category: K },
    { src: G10, category: K },
    { src: G11, category: K },
    { src: G13, category: K },
    { src: G15, category: K },
    { src: G28, category: K },
    { src: G43, category: K },
    { src: G44, category: K },

    // Natural & Curly Styles
    { src: G2, category: N },
    { src: G39, category: N },
    { src: G63, category: N},
    { src: G54, category: N },
    { src: G64, category: N },
    { src: G62, category: N },
  ];

  const handleCategoryClick = (category) => setSelectedCategory(category);

  const handleImageClick = (src) => {
    setCurrentImage({ src });
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  return (
    <div className="gallery-section">
      <h1>Welcome to Kadi&apos;s Hair Gallery</h1>
      <p>Your style, our passion.</p>

      {/* Category Tabs */}
      <div className="category-tabs">
        {categories.map((category) => (
          <button
            key={category}
            className={`tab-button ${selectedCategory === category ? "active" : ""}`}
            onClick={() => handleCategoryClick(category)}
          >
            {category}
          </button>
        ))}
      </div>

      {/* Gallery Grid */}
      <div className="gallery-grid">
        {images
          .filter((img) => selectedCategory === "All" || img.category === selectedCategory)
          .map((image, index) => (
            <div
              key={index}
              className="gallery-item"
              onClick={() => handleImageClick(image.src)}
            >
              <img src={image.src} alt={`Gallery ${index + 1}`} />
            </div>
          ))}
      </div>

      {/* Modal */}
      <Modal isOpen={isModalOpen} onClose={closeModal} imageSrc={currentImage.src} />
    </div>
  );
};

export default Gallery;
